import { Reporter } from 'io-ts/Reporter';
import { Context, getFunctionName, ValidationError } from 'io-ts';
import { fold } from 'fp-ts/lib/Either';

import { isPlainObject } from '../../../src/shared/utils/isPlainObject';

const stringify = (value: any): string => {
  if (typeof value === 'function') {
    return getFunctionName(value);
  }

  if (typeof value === 'number' && !isFinite(value)) {
    if (isNaN(value)) {
      return 'NaN';
    }

    return value > 0 ? 'Infinity' : '-Infinity';
  }

  if (isPlainObject(value)) {
    return '{...}';
  }

  try {
    return JSON.stringify(value);
  } catch (error) {
    return String(value);
  }
};

const getContextPath = (context: Context): string => context.map(({ key }) => key).join('.');

const getMessage = (error: ValidationError): string =>
  error.message !== undefined
    ? error.message
    : `Invalid value ${stringify(error.value)} supplied to ${getContextPath(error.context)}`;

const failure = (errors: Array<ValidationError>): Array<string> => errors.map(getMessage);

const success = (): Array<string> => ['No errors!'];

const SimpleReporter: Reporter<Array<string>> = {
  report: fold(failure, success),
};

export { SimpleReporter };
